import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import useBarChartData from '../../../hooks/admin/useBarChartData';
import useFetchTotals from '../../../hooks/admin/useFetchTotals';
import BarChart from './BarChart';
import DashTable from './DashTable';
import PieChart from './PieChart';
import TopTable from './TopTable';

const Index = () => {
  const { company } = useParams();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const {
    totals,
    loading: loadingTotals,
    error: errorTotals,
  } = useFetchTotals({ company });
  const {
    barChartData,
    loading: loadingBars,
    error: errorBars,
  } = useBarChartData({ company });

  if (loadingTotals || loadingBars) return <Loader />;
  if (errorTotals || errorBars) return <div>Error al cargar datos.</div>;

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const filteredTotalsData = totals.filter(
    (item) => item.year === parseInt(selectedYear)
  );
  const filteredBarChartData = barChartData[selectedYear] || {
    labels: [],
    datasets: [],
  };
  const filteredPaymentMethods =
    barChartData[selectedYear]?.paymentMethods || {};

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Pagos y Recaudación por Mes - ${selectedYear}`,
      },
    },
  };

  return (
    <div className='page dash'>
      <h2 className='title'>Bienvenido al dashboard de administración.</h2>
      <div className='form-group'>
        <label htmlFor='year'>Seleccionar Año:</label>
        <select
          id='year'
          value={selectedYear}
          onChange={handleYearChange}>
          {Array.from(
            { length: new Date().getFullYear() - 2024 + 1 },
            (_, i) => 2024 + i
          ).map((year) => (
            <option
              key={year}
              value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div className='bar-section-container'>
        <DashTable
          data={filteredTotalsData}
          company={company}
        />
        <BarChart
          data={filteredBarChartData}
          options={options}
          company={company}
        />
      </div>
      <div className='right-section'>
        <PieChart
          data={filteredPaymentMethods}
          company={company}
        />
      </div>
      <div className='tables-container'>
        <TopTable
          type='foundation'
          company={company}
        />
        <TopTable
          type='program'
          company={company}
        />
      </div>
    </div>
  );
};

export default Index;
